const { isEmpty, initOSSInstance, ERROR } = require('../util');
const errorRender = require('../views/error.dot');

window.ExtendsDefine = function(openapi) {
  if (!window.OSS) {
    throw new Error('请先引入oss-sdk');
  }

  openapi.setConfig({
    prefix: 'aliyun'
  });

  function errorUIHandler(code, errType) {
    const { MSG, CODE } = ERROR;
    const errorDom = errorRender({
      message: MSG[code] || MSG.default,
      errCode: CODE[errType] || CODE.default
    });
  
    $('body').append(errorDom);
    $('.wps-widget-loading').hide();
  }

  function bindEvent() {
    //刷新签名
    openapi.on('message.error', function(res) {
      const data = res.data || {};
      const status = data.status;
      const responseText = data.responseText || '';

      if (data.url) {
        let reqUrl = new URL(data.url);
        // 如果请求meta.json失败，则抛出异常提示
        if( /meta\.json$/gi.test(reqUrl.pathname)) {
          const xmlDoc = $.parseXML(responseText);
          const errType = $(xmlDoc).find('Code').text();
          errorUIHandler(status, errType);
          reqUrl = null;
        }
      }
    });
  }

  function setBaseConfig() {
    openapi.setConfig({
      enableMessageUI: false,
      parseUrl(url) {
        const client = openapi.getConfig('client');
        if (client) {
          const pathInfo = openapi.parseUrl(url);
          let timestamp = openapi.getConfig('timestamp') || {};
          let { serverTime, expires = 1800 } = timestamp;

          if (!isEmpty(serverTime)) {
            // 开始校准本地时间
            const localTime = Math.round(+new Date() / 1000);
            url = client.signatureUrl(pathInfo.pathname, {
              expires: (serverTime || localTime) - localTime + expires
            });
          } else {
            url = client.signatureUrl(pathInfo.pathname);
          }
        }
        return url;
      },
      couldRetry(tryCount) {
        //tryCount 当前已经重试的次数 会覆盖 _view_env_.reqJson 的逻辑
        return new Promise(function(resolve) {
          if (tryCount > 35) {
            // 最多重试次数
            resolve(false);
          } else {
            let tryDelay = 0;
            if (tryCount < 2) {
              // 0 - 1
              tryDelay = 250;
            } else if (tryCount <= 11) {
              // 2 - 11
              tryDelay = 500;
            } else {
              // 12 - 35
              tryDelay = 1000;
            }

            setTimeout(function() {
              resolve(true); // 执行重试
            }, tryDelay);
          }
        });
      }
    });
  }

  function getOSSInstance() {
    const {
      region,
      accessKeyId,
      accessKeySecret,
      stsToken,
      bucket,
      url
    } = window._preview_params;

    window._data_.path = url;
    return initOSSInstance(openapi, {
      region,
      bucket,
      accessKeyId,
      accessKeySecret,
      stsToken
    });
  }

  function init() {
    bindEvent();
    setBaseConfig();
    return getOSSInstance();
  }

  return init();
}